
import barba from '@barba/core';
import LocomotiveScroll from 'locomotive-scroll';

export default class{

	constructor(){
        barba.hooks.once((data) => {
            const indexScroll = document.querySelector("#p-index__scroll");
            if(indexScroll) {
                this.init()
            }
        })
        barba.hooks.leave((data) => {
            window.removeEventListener("resize",this.handleResize.bind(this))

            if(this.isInit){
                document.body.classList.remove('home')
                this.lscroll.destroy()
            }
        })
        barba.hooks.after((data) => {
            const indexScroll = document.querySelector("#p-index__scroll");
            if(indexScroll) {
                this.init()
            }
        });
    }
    init (){
        
        this.options = {
            el: document.querySelector('[data-scroll-container]'),
            smooth: true,
            direction: 'horizontal',
            multiplier: 1,
            horizontalGesture: true
        }

        this.isInit = false
        this.handleResize();

        if(this.isInit){
            if(window.location.hash){
                const targetHash = document.querySelector(window.location.hash);
                if(targetHash){
                    this.lscroll.scrollTo(targetHash)
                }
            }
        }

        const scrollLinks = document.querySelectorAll('[data-scroll-link]')
        if(scrollLinks.length > 0){
            if(this.isInit){
                scrollLinks.forEach(el => {
                    el.addEventListener('click',(e)=>{
                        e.preventDefault()
                        const targetHash = document.querySelector(el.getAttribute('data-scroll-link'));
                        if(targetHash){
                            this.lscroll.scrollTo(targetHash)
                        }
                    })
                })
            }
        }
        window.addEventListener("resize",this.handleResize.bind(this))
    }

    handleResize = () => {
        if(window.innerWidth > 1025){
            if(!this.isInit){
                this.lscroll = new LocomotiveScroll(this.options);
                this.changeCopyright()
                document.body.classList.add('home')
                this.isInit = true
            }
        }else{
            if(this.isInit){
                const scrollEl = document.querySelectorAll("[data-scroll-section]")
                scrollEl.forEach(el => {
                    el.removeAttribute("style")
                })
                document.body.classList.remove('home')
                this.lscroll.destroy()
                this.isInit = false
            }
        }
    }

    changeCopyright(){
        // 今回の交差を監視する要素
        const hero = document.querySelector("#hero--wrapper");
        const copyrightEl = document.querySelector("#p-index__floating--copy");
        if(hero){

            this.lscroll.on("scroll",(args) => {
                if(this.isInit){
                    
                    if(args.scroll.x > 450){
                        copyrightEl.classList.add('-intersect')
                    }else{
                        copyrightEl.classList.remove('-intersect')

                    }
                }
            })
            // const options = {
            //     root: null, // 今回はビューポートをルート要素とする
            //     rootMargin: "0px 80%", // ビューポートの中心を判定基準にする
            //     threshold: 0 // 閾値は0
            // };

            // /**
            //  * 交差したときに呼び出す関数
            //  * @param entries
            //  */
            // const doWhenIntersect = (entries) => {
            //     // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
            //     entries.forEach(entry => {
            //         if (entry.isIntersecting) {
            //             copyrightEl.classList.add('-intersect')
            //         }else{
            //             copyrightEl.classList.remove('-intersect')
            //         }
            //     });
            // }


            // const observer = new IntersectionObserver(doWhenIntersect, options);
            // observer.observe(hero);

        }
    }
}